import { Color, Font, Placement } from 'zens-storybook'
import { useFloorplanAsset } from 'zens-store'
import { G, Text } from 'react-native-svg'

export interface Props {
  label: string
  uri: string
  width?: number | string
  height?: number | string
  placement?: Placement
  fontSize?: number
}

const FloorplanAsset = (props: Props) => {
  const { uri, width, height, placement, fontSize, label } = props
  const asset = useFloorplanAsset(uri)
  const imageWidth =
    width ||
    (!isNaN(height as any) && asset.data && (asset.data?.width * parseFloat(`${height}`)) / asset.data?.height) ||
    asset.data?.width
  const imageHeight =
    height ||
    (!isNaN(width as any) && asset.data && (asset.data?.height * parseFloat(`${width}`)) / asset.data?.width) ||
    asset.data?.height

  const halfWidth = !isNaN(imageWidth as any) ? parseFloat(`${imageWidth}`) / 2 : 0
  const halfHeight = !isNaN(imageHeight as any) ? parseFloat(`${imageHeight}`) / 2 : 0

  const placementRotation = placement
    ? Math.round((((placement.rotation < 0 ? placement.rotation + 360 : placement.rotation) + 45) / 180) % 1) * 90
    : 0

  return (
    <G
      transform={`translate(${placement?.x},${placement?.y})rotate(${placement?.rotation}, ${halfWidth}, ${halfHeight})`}
    >
      <Text
        fontFamily={`${Font.medium}, Helvetica, Arial, sans-serif`}
        fontSize={fontSize || halfWidth / 2.5}
        fill={Color.darkGreyBlue}
        textAnchor="middle"
        x={typeof imageWidth === 'number' ? imageWidth / 2 : undefined}
        y={typeof imageHeight === 'number' ? imageHeight / 2 : undefined}
        transform={`rotate(${-(placement?.rotation || 0) + placementRotation}, ${halfWidth}, ${halfHeight})`}
      >
        {label}
      </Text>
    </G>
  )
}

export default FloorplanAsset
